<template>
    <div>
        <div v-if="titleShow" class="-page-header">
            <div class="-page-header-title__wrapper">
                <div class="-page-header-title-main__wrapper">
                    <h1 class="-page-header-title-main__title">{{pageTitle}}</h1>
                </div>
                <div class="-page-header-title-locations-and-shortcuts__wrapper">
                    <ul>
                        <li>
                            <div class="-page-header-title-locations__wrapper">
                                <div v-for="(item, index) in locationList" :key="index" :title="locationList.join(' > ')">
                                    <ul>
                                        <li :class="['-page-header-title-locations__item', {'-page-header-title-locations__item-current': index === (locationList.length-1)}]" :label="item">{{ item }}</li>
                                        <li v-if="locationList.length > 0 && index !== (locationList.length-1)" class="-page-header-title-location__seperator"/>
						            </ul>
					            </div>
				            </div>
			            </li>
		            </ul>
	            </div>
            </div>
        </div>

        <slot />
    </div>
</template>
<script>
export default {
    name : 'AICCPage',
    props: {
        pageId: {
            type: String,
            default: null,
        },
        title: {
            type: String,
            default: '',
        },
        titleShow:{
            type:Boolean,
            default:true,
        },
    },
    data() {
        return {
            pageTitle: this.title ? this.title : '',
            locationList: [],
            realPageId: this.pageId,
        }
    },
    computed: {
    },
    created(){},
    mounted(){
        if(this.realPageId) {
            const meta = this.$store.getters.getPageMeta(this.realPageId);
            if(meta) {
                this.pageTitle = this.$t(meta.pageInfo.pageTitleMessageResourceId);
                this.generateLocations(meta.pageInfo);
            }
        } else {
            this.locationList.push(this.title);
        }
    },
    methods: {
        _findComponent(){
            let currentComponent = this;
            while(currentComponent) {
                if(currentComponent.$options._componentTag === COMPONENT_TAG_NAME_PAGE) {
                    return currentComponent;
                }
                currentComponent = currentComponent.$parent;
            }
            return null;
        },
        generateLocations() {
            const menuPath = this.$store.state.menu_path;
            this.locationList = [];
            if(!utils.isEmpty(menuPath)) {
                this.locationList.push(this.$store.getters.applicationName);
                for(let index = 0 ; index < menuPath.length - 1 ; index++) {
                    this.locationList.push(menuPath[index].menuName);
                }
            }
            this.locationList.push(this.pageTitle);
        }
    },
}
</script>
